module.exports = __webpack_public_path__ + "img/66.e60d4dc2.jpeg";